Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.httpGetMethod = "GET";
exports.httpPutMethod = "PUT";
exports.httpPostMethod = "POST";
exports.httpDeleteMethod = "DELETE";

exports.ReviewsApiContentType = "application/json";
exports.getReviewsAPiEndPoint = "reviews/reviews";
exports.getBusinessReviewsAPiEndPoint = "bx_block_reviews/business_reviews";
exports.getEndUSerSingINAPiEndPoint = "/account_block/accounts/end_user_login";
exports.getEndUSerOTPVerifyAPiEndPoint = "/account_block/accounts/verify_otp_end_user";
exports.getEndUSerPostReviewAPiEndPoint = "/bx_block_reviews/business_reviews";
exports.reviewLikeApiEndPoint = "/bx_block_cfembedintegration/widgets/89/review_like";

exports.errorTitle = "Error";
exports.errorAllFieldsAreMandatory = "All fields are mandatory.";

exports.titleTitle = "Title";
exports.descriptionTitle = "Description";
exports.accountIdTitle = "Account Id";
exports.anonymousTitle = "Anonymous";

exports.description = "Description";
exports.account_id = 1;
exports.anonymous = false;
exports.namePlaceHolder = "Name";
exports.titlePlaceHolder = "Title";
exports.numberPlaceHolder = "Phone number";
exports.descriptionPlaceHolder = "Description";

exports.labelTitleText = "Reviews";
exports.labelBodyText = "Reviews Body";

exports.btnExampleTitle = "CLICK ME";
// Customizable Area End